"use strict";

class StationSettingsTypeCtrl {
    constructor(datamodel, $rootScope, $scope, $state, $stateParams, $timeout, $transitions) {
        this.datamodel = datamodel;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$timeout = $timeout;
        this.$transitions = $transitions;

        this.colors = this.datamodel.colors;
        this.icons = this.datamodel.icons;

        this.type = null;
        this.templateUrl = null;

        this.datamodel.isReady.then(this.fetch.bind(this));

        $scope.miniColorConfig = {
            inline: true
        };

        //Configurate ui-sortable
        this.fieldSortableOptions = {
            axis: 'y',
            opacity: 0.6,
            stop: (e, ui) => {

                this.type.fields.map((field, i) => {
                    field.order = i;
                    return field;
                });
            }
        };
    }

    fetch() {
        //get the data for this id
        this.$scope.$apply(() => {
            let modelData = this.datamodel.data[this.$stateParams.modelName];

            for (let index in modelData) {
                if (!modelData.hasOwnProperty(index)) continue;

                if (modelData[index].id == this.$stateParams.typeId) {
                    this.type = modelData[index];
                    break;
                }
            }

            if (this.type == null) {//not found
                this.$timeout(() => {
                    this.$state.go('^');
                });
                return;
            }
            this.templateUrl = '/partial/app.partials.stationsettings.datamodel.types.' + this.type.model;
        });
    }

    loadingIncludeComplete() {

        //after loading and rendering
        this.loaded = true;
    }

    checkActiveType(id) {
        return this.$state.params.fieldId == id;
    }

    openField(field) {
        if (!this.checkActiveType(field.id)) {
            this.$state.go('stationsettings.datamodel.type.field', {fieldId: field.id});
        }
    }

    newField() {

            let newField = {
                id: this.datamodel.generateId(),
                name: '',
                options: {},
            };

            let index = this.type.fields.push(newField);
            newField.order = index - 1;
            this.openField(newField);

    }

    remove(e, index) {
        e.preventDefault();
        let id = this.type.fields[index].id;

        if (this.$state.params.fieldId == id) {

            this.$state.go('^');
            let unregisterChange = this.$transitions .onSuccess({ }, (transition) => {

                this.type.fields.splice(index, 1);
                unregisterChange();
            });
        } else {
            this.type.fields.splice(index, 1);
        }
    }

}

StationSettingsTypeCtrl.$inject = [
    'datamodel',
    '$rootScope',
    '$scope',
    '$state',
    '$stateParams',
    '$timeout',
    '$transitions'
];

module.exports = StationSettingsTypeCtrl;